<template>
  <section>
    <nav-top
      ref="topNav"
      @toggleBar="toggleBar"
    />
    <div
      class="custom-sidebar"
      :class="{'active': toggleClass, 'inactive': !toggleClass, 'hide-it': !isLoaded}"
    >
      <ul class="nav flex-column mb-0">
        <li class="nav-item">
          <b-link
            href="#"
            class="nav-link font-italic"
            @click.prevent="go('')"
          >
            <i class="fa fa-th-large mr-3"></i>
            <span class="custom-menu-link">{{ $t('left.link.home') }}</span>
          </b-link>
        </li>
        <li class="nav-item"
          v-if="!isRagOnlyUser">
          <a
            href="#"
            class="nav-link font-italic"
            @click.prevent="newRequest"
          >
            <i class="fas fa-folder-open mr-3"></i>
            <span class="custom-menu-link">{{ $t(newRequestLabel) }}</span>
          </a>
        </li>
        <li
          class="nav-item"
          v-if="showScanproMenuItem">
          <a
            href="#"
            class="nav-link font-italic"
            @click.prevent="go('scanpro')"
          >
            <i class="fas fa-qrcode mr-3"></i>
            <span class="custom-menu-link">ScanPro Assist</span>
          </a>
        </li>
        <li class="nav-item"
          v-if="!isMahle && !isRagOnlyUser">
          <a
            href="#"
            class="nav-link font-italic"
            @click.prevent="go('location')"
          >
            <i class="fas fa-warehouse mr-3"></i>
            <span class="custom-menu-link">{{ $t(locationLabel) }}</span>
          </a>
        </li>
        <li class="nav-item"
          v-if="!isMahle && !isRagOnlyUser">
          <a
            href="#"
            class="nav-link font-italic"
            @click.prevent="go('user')"
          >
            <i class="fas fa-user mr-3"></i>
            <span class="custom-menu-link">{{ $t('profile.label.title') }}</span>
          </a>
        </li>
        <li class="nav-item"
          v-if="!isMahle && !isRagOnlyUser">
          <b-link
            href="#"
            class="nav-link font-italic"
            @click.prevent="go('about')"
          >
            <i class="fas fa-info mr-3"></i>
            <span class="custom-menu-link">{{ $t(aboutUsLabel) }}</span>
          </b-link>
        </li>
        <!-- RAG menu item - shown when user has ShowRAG permission -->
        <li class="nav-item" v-if="showRagMenuItem">
          <a
            href="#"
            class="nav-link font-italic"
            @click.prevent="go('rag')"
          >
            <i class="fas fa-bars mr-3"></i>
            <span class="custom-menu-link">{{ $t('menu.label.rag') }}</span>
          </a>
        </li>
        <li class="nav-item">
          <b-link
            href="#"
            class="nav-link font-italic"
            @click.prevent="logout"
          >
            <i class="fas fa-sign-out-alt mr-3"></i>
            <span class="custom-menu-link">{{ $t('logout.label.title') }}</span>
          </b-link>
        </li>
      </ul>
    </div>
    <div
      class="custom-background"
      v-show="toggleClass"
      @click.prevent="closeMenu"
    ></div>
    <div class="container custom-main">
      <slot @event="processEvent" />
    </div>
    <div
      id="rightSlideOut"
      class="slideOut slideOutRight"
      v-bind:style="slideOutStyle"
      v-show="showRightSlideOut"
    >
      <div class="slideOutTitle"><a
          href="#"
          @click.prevent="closeSlideOut"
        ><i class="fas fa-times"></i></a><span>{{ slideOutTitle }}</span></div>
      <chat />
    </div>
    <dt-confirm
      v-model="actionConfirm"
      :confirmTitle="confirmTitle"
      :confirmNoAction="confirmNoAction"
      :confirmAction="confirmAction"
      :confirmQuestion="confirmQuestion"
      @closing="closeModal"
      @proceed="proceedNewRequest"
    />
    <dialog-opening-hours
      v-model="isDialogOpen"
      :supportEmail="supportEmailAddress"
      @closing="closeDialog"
    />
    <client-survey-modal
      v-if="surveyWorkOrderId != null"
      v-model="showSurvey"
      :work-order-id="surveyWorkOrderId"
      @submitted="onSurveyDone"
      @skipped="onSurveyDone"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import NavTop from '@/components/navigation/nav-top'
import NavLeft from '@/components/navigation/nav-left'
import Chat from '@/components/chat/chat'
import DtConfirm from '@/components/utilities/modal/dt-confirm'
import DialogOpeningHours from '@/components/openinghours/dialog-opening-hours'
import ClientSurveyModal from '@/components/survey/ClientSurveyModal.vue'
import globals from '@/plugins/globals.js'
import * as types from '@/store/modules/auth/types'
export default {
  name: 'layout-sidebar',
  components: {
    NavTop,
    NavLeft,
    Chat,
    DtConfirm,
    DialogOpeningHours,
    ClientSurveyModal
  },
  data() {
    return {
      version: window.config ? window.config.version : '',
      isLoaded: false,
      toggleClass: false,
      showRightSlideOut: false,
      slideOutStyle: '',
      slideOutTitle: '',
      actionConfirm: null,
      isDialogOpen: null,
      confirmTitle: this.$t(this.newRequestLabel),
      confirmNoAction: this.$t('no'),
      confirmAction: this.$t('yes'),
      confirmQuestion: this.$t('submit.question'),
      supportEmailAddress: '',
      showSurvey: false,
      surveyWorkOrderId: null
    }
  },
  updated() {
    this.isLoaded = true
  },
  mounted() {
    this.$root.$on('heartbeat', this.pulseHeartbeat)
    this.$root.$on('slideout', this.showSlideOut)
    this.getConfigurationValues()
    if (globals.isClientSurveyEnabledForThisTenant()) {
      // wait a tick so BootstrapVue modal system is ready
      setTimeout(() => {
        this.tryOpenPendingSurvey()
      }, 250)
    }
  },
  async created() {
    await this.getTenantDetails()
  },
  computed: {
    ...mapGetters('openingHours', ['isOpen', 'tenantDetails']),
    appId() {
      return globals.appId()
    },
    isBannerEnabled() {
      let env = window.config ? window.config.environment : ''
      return env !== 'prod'
    },
    isUK: {
      get() {
        let _isUK = false
        let _appId = globals.appId()
        if (parseInt(_appId) === 1) {
          _isUK = true
        }
        return _isUK
      }
    },
    showScanproMenuItem: {
      get() {
        return (globals.appId() !== 5 && // Don't show if it's Protech
               globals.appId() !== 1) || // Don't show if it's UK only
               (globals.appId() === 1 && (globals.isStGobain())) // Show for St. Gobain
      }
    },
    isMahle: {
      get() {
        return globals.isMahle()
      }
    },
    isOpeningHoursEnabled: {
      get() {
        return globals.isOpeningHoursEnabled()
      }
    },
    isMahleOpeningHoursEnabled: {
      get() {
        return globals.isMahleOpeningHoursEnabled()
      }
    },
    newRequestLabel: {
      get() {
        let _newRequestLabel = ''
        _newRequestLabel = 'request.title.newrequest'
        if (globals.isClever()) {
          _newRequestLabel = 'request.title.clever.newrequest'
        }
        return _newRequestLabel
      }
    },
    locationLabel() {
      return (globals.isClever() ? 'left.link.clever.location' : 'left.link.location')
    },
    aboutUsLabel() {
      return (globals.isClever() ? 'left.link.clever.about' : 'left.link.about')
    },
    // Hide menu items if the user is RAG Only
    isRagOnlyUser() {
      return this.$store.getters['auth/isRagOnly']
    },
    // Show RAG menu item for users with ShowRAG permission
    showRagMenuItem() {
      return this.$store.getters[types.SESSION_SHOW_RAG]
    }
  },
  methods: {
    ...mapActions('auth', ['clearToken']),
    ...mapActions('serviceRequests', ['setNewRequest']),
    ...mapActions('openingHours', ['isShopOpen', 'getTenantDetails']),
    ...mapActions('configuration', ['getConfigurationValues']),
    closeDialog() {
      this.isDialogOpen = false
    },
    closeModal() {
      this.actionConfirm = null
    },
    pulseHeartbeat(event) {
      console.log('An Event Occurred', event)
    },
    go(where) {
      const path = where ? `/${where}` : '/'
      this.$router.push(path)
      this.toggleBar(false)
    },
    logout() {
      this.clearToken()
      window.location.assign('/')
    },
    toggleBar(toggle) {
      this.toggleClass = toggle
    },
    closeMenu() {
      this.$refs.topNav.closeMenu()
    },
    getTenantDetailsArray() {
      let tenantDetails

      // Safely parse tenantDetails if it's a string
      try {
        tenantDetails = typeof this.tenantDetails === 'string'
          ? JSON.parse(this.tenantDetails)
          : this.tenantDetails
      } catch (error) {
        console.error('Invalid JSON structure:', error)
        return []
      }

      // Validate tenantDetails structure
      if (!tenantDetails || !tenantDetails.Items || !Array.isArray(tenantDetails.Items) || tenantDetails.Items.length === 0) {
        console.warn('Invalid tenant details format.')
        return []
      }

      return tenantDetails.Items
    },
    async newRequest() {
      const tenantDetails = this.getTenantDetailsArray()

      if (this.isOpeningHoursEnabled || this.isMahleOpeningHoursEnabled) {
        // Determine the correct shop type
        const shopType = this.isOpeningHoursEnabled ? tenantDetails[0].ID : tenantDetails[1].ID // first entry in array is always UK/CL/SG/AU, 2nd is MAHLE

        // Check if the shop is open
        await this.isShopOpen(shopType)

        this.toggleBar(false)

        // Handle navigation based on open status
        if (this.isOpen) {
          this.isDialogOpen = null
          this.isUK ? this.proceedNewRequest() : (this.actionConfirm = true)
        } else {
          this.supportEmailAddress = tenantDetails[shopType - 1].SupportEmail // array is 0 based.
          this.isDialogOpen = true
        }
        return
      }

      // Default behavior when opening hours are not enforced
      this.toggleBar(false)
      this.isUK ? this.proceedNewRequest() : (this.actionConfirm = true)
    },
    proceedNewRequest() {
      this.actionConfirm = null
      globals.currentPage = 'Submit'
      this.setNewRequest()
      this.$router.replace('/servicerequest/0')
    },
    closeSlideOut() {
      this.showRightSlideOut = false
      this.slideOutStyle = ''
      this.slideOutTitle = ''
      this.$root.$emit('closeSlideOut')
    },
    showSlideOut(options) {
      this.showRightSlideOut = false
      this.slideOutStyle = ''
      this.slideOutTitle = ''
      if (options.direction === 'right') {
        this.slideOutStyle = options.style
        this.slideOutTitle = options.title
        this.showRightSlideOut = true
      }
    },
    tryOpenPendingSurvey () {
      const raw = localStorage.getItem('survey_pending_workOrderId')
      const workOrderId = parseInt(raw || '0', 10)

      if (!Number.isInteger(workOrderId) || workOrderId <= 0) return

      // Optional TTL so it doesn't open days later
      const setAt = parseInt(localStorage.getItem('survey_pending_setAt') || '0')
      const tooOld = setAt && (Date.now() - setAt > 10 * 60 * 1000) // 10 mins
      if (tooOld) {
        localStorage.removeItem('survey_pending_workOrderId')
        localStorage.removeItem('survey_pending_setAt')
        return
      }

      this.surveyWorkOrderId = workOrderId
      this.$nextTick(() => {
        this.showSurvey = true
      })
    },

    onSurveyDone () {
      // clear the pending flag once user acts
      localStorage.removeItem('survey_pending_workOrderId')
      localStorage.removeItem('survey_pending_setAt')

      this.showSurvey = false
      this.surveyWorkOrderId = null
    }
  },
  beforeDestroy() {
    this.$root.$off('heartbeat')
    this.$root.$off('slideout')
  }
}
</script>
<style lang="scss" scoped>
.custom-main {
  margin-top: 5px;
  padding: 10px;
}
.custom-background {
  position: absolute;
  // margin-top: 8px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
  z-index: 99998;
  // height: 100%;
  height: -moz-calc(100% - (6rem));
  height: -webkit-calc(100% - (6rem));
  height: calc(100% - (6rem));
}
.hide-it {
  display: none;
}
.custom-sidebar {
  position: absolute;
  // margin-top: 8px;
  width: 17rem;
  background-color: rgb(121, 121, 121);
  z-index: 99999;
  // height: 100%;
  height: -moz-calc(100% - (6rem));
  height: -webkit-calc(100% - (6rem));
  height: calc(100% - (6rem));
  transform: translateX(-100%);
  -webkit-transform: translateX(-100%);
  li {
    padding-bottom: 1px;
    border-bottom: 1px solid #b6b6b6;
    white-space: nowrap;
  }
  a {
    font-size: 1.2em;
    font-weight: 600;
    color: #ffffff;
  }
  a:hover {
    color: #51b04a;
  }
}
.active {
  animation: slide-in 0.5s forwards;
  -webkit-animation: slide-in 0.5s forwards;
}
.inactive {
  animation: slide-out 0.5s forwards;
  -webkit-animation: slide-out 0.5s forwards;
}
@keyframes slide-in {
  100% {
    transform: translateX(0%);
  }
}
@-webkit-keyframes slide-in {
  100% {
    -webkit-transform: translateX(0%);
  }
}
@keyframes slide-out {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
@-webkit-keyframes slide-out {
  0% {
    -webkit-transform: translateX(0%);
  }
  100% {
    -webkit-transform: translateX(-100%);
  }
}
.custom-menu-link {
  position: absolute;
  left: 70px;
}
.slideOut {
  background-color: #ffffff;
  position: absolute;
  z-index: 10001;
  -moz-box-shadow: 0px 10px 18px 0px #ccc;
  -webkit-box-shadow: 0px 10px 18px 0px #ccc;
  box-shadow: 0px 10px 18px 0px #ccc;
}
.slideOutTitle {
  position: relative;
  height: 44px;
  width: 100%;
  background-color: #338c2f;
  color: #ffffff;
  font-weight: 500;
  border-bottom: 1px solid #686868;
  margin: 0;
  padding-top: 6px;
  vertical-align: middle;
  text-align: center;
  font-size: 1.2em;
  a {
    position: absolute;
    color: #ffffff;
    top: 4px;
    left: 4px;
    height: 28px;
    width: 28px;
  }
}
.slideOutRight {
  display: block;
  right: 0;
  top: 0;
  height: 100%;
  border-top: 1px solid #686868;
  border-left: 1px solid #686868;
  border-bottom: 1px solid #686868;
}
</style>



// WEBPACK FOOTER //
// src/layouts/side-nav.vue